import {Component, Input} from '@angular/core';
import {MarkdownComponent} from '../../../../../shared/components/markdown/markdown.component';
import {AssetVersionPipe} from '../../../../../pipes/asset-version.pipe';
import {NgIf} from '@angular/common';

@Component({
  selector: 'app-copilot-web-insights-message',
  imports: [
    MarkdownComponent,
    NgIf,
    AssetVersionPipe
  ],
  templateUrl: './copilot-web-insights-message.component.html',
  styleUrl: './copilot-web-insights-message.component.scss'
})
export class CopilotWebInsightsMessageComponent {
  @Input() webInsights: string | undefined;
}
